// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__ggop9","summary":"CartItem_summary__7Dd1F","price":"CartItem_price__xMBD7","amount":"CartItem_amount__NuuXi","actions":"CartItem_actions__wyNdz"};